import { DTOFrameNodeStructureListResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class FigmaFrameStructuresEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/figma-frames/node-structures`,
      DTOFrameNodeStructureListResponse
    );
  }
}
